import { Button } from '@insurancemenu/imenu-components-lib';
import { boxShadows, colors, typography } from '@insurancemenu/imenu-components-lib/dist/utils';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled, { css, CSSProp } from 'styled-components';
import { CategoryStatus } from 'store/modules/subscriber/subscriber-imq/types';

export const MedicalCategoryCardStyled = styled.div<{ $status: CategoryStatus }>`
  color: ${colors.neutral[900]};
  box-shadow: ${boxShadows.dark[4]};
  padding: 1.9rem 2.5rem 1.5rem;
  border-top: 7px solid;
  border-radius: 0 0 4px 4px;

  ${breakpointsMQ4.sm.down} {
    padding: 1.6rem;
  }
  ${({ $status }): CSSProp => {
    switch ($status) {
      case CategoryStatus.COMPLETED:
        return css`
          border-color: ${colors.green[600]};
        `;
      case CategoryStatus.DETAILS_MISSING:
        return css`
          border-color: ${colors.yellow[600]};
        `;
      case CategoryStatus.NOT_STARTED:
        return css`
          border-color: ${colors.red[600]};
        `;
      default:
        return null;
    }
  }};
`;

export const CardHeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  ${breakpointsMQ4.sm.down} {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.2rem;
  }
`;

export const CategoryNameButtonStyled = styled(Button)<{ $hasConditions: boolean }>`
  ${typography.bold[20]}
  color: ${colors.neutral[900]};
  height: auto;
  padding: 0;
  width: auto;
  text-align: left;
  white-space: normal;
  cursor: ${({ $hasConditions }): string => ($hasConditions ? 'pointer' : 'default')};
  overflow-wrap: anywhere;

  svg {
    flex-shrink: 0;
  }

  ${breakpointsMQ4.sm.down} {
    ${typography.bold[20]};
    width: 100%;
    flex: none;

    svg {
      width: 2.4rem;
      height: 2.4rem;
    }
  }
`;

export const ConditionsInfoStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 2rem;
  margin-top: 2.4rem;

  ${breakpointsMQ4.sm.down} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    margin-top: 1.6rem;
  }
`;

export const ConditionsTitleStyled = styled.h4`
  margin: 0;
  ${typography.bold[16]}
  color: ${colors.neutral[700]};
`;

export const ConditionsTextStyled = styled.p`
  margin: 0;
  ${typography.regular[16]}
  color: ${colors.neutral[900]};
`;

export const EditCategoryButtonStyled = styled(Button)`
  flex-shrink: 0;

  svg {
    flex-shrink: 0;
  }

  ${breakpointsMQ4.sm.down} {
    width: 100%;
  }
`;

export const ConditionsBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-top: 1px solid ${colors.neutral[400]};
  margin-top: 2rem;
  padding: 3rem 0 2rem;

  ${breakpointsMQ4.sm.down} {
    margin-top: 1.6rem;
    padding: 2rem 0 1.6rem;
  }
`;
